import { isArray } from 'lodash'

export function useFileFormatting() {
  const formatFileValue = (value: any): any => {
    if (!value) return {}

    try {
      const parsedValue = typeof value === 'string' ? JSON.parse(value) : value

      if (isArray(parsedValue)) {
        return parsedValue[0] || {}
      }

      return parsedValue
    } catch (error) {
      console.error('Error parsing file value:', error)
      return {}
    }
  }

  return {
    formatFileValue
  }
}
